import {
    selectedCategoryIdSelector,
    selectedDateTimestampInMsSelector,
    searchValueSelector,
    isLoadingSelector,
    currentPageSelector,
    alertHistoryListSelector,
    isEmptyAlertHistoryListSelector,
    listSelector,
} from '../selectors';
import { filterEvents, getSortedListByDate } from '../utils';
import { ALERT_HISTORY, IS_EMPTY_ALERT_HISTORY_LIST, LIST } from '../constants';

jest.mock('../utils', () => ({
    filterEvents: jest.fn(),
    getSortedListByDate: jest.fn(),
}));

describe('alert/history Redux Selectors', () => {
    const mockState = {
        'alert/history': {
            selectedCategoryId: 'category1',
            selectedDateTimestampInMs: 1612051200000,
            searchValue: 'keyword',
            isLoading: false,
            currentPage: 1,
            list: [
                { id: 1, timestamp: 1612051200000, category: 'category1', message: 'Event 1' },
                { id: 2, timestamp: 1612051210000, category: 'category2', message: 'Event 2' },
                { id: 3, timestamp: 1612051220000, category: 'category1', message: 'Event 3' },
            ],
        },
    };

    it('should select the correct selectedCategoryId', () => {
        expect(selectedCategoryIdSelector(mockState)).toEqual('category1');
    });

    it('should select the correct selectedDateTimestampInMs', () => {
        expect(selectedDateTimestampInMsSelector(mockState)).toEqual(1612051200000);
    });

    it('should select the correct searchValue', () => {
        expect(searchValueSelector(mockState)).toEqual('keyword');
    });

    it('should select the correct isLoading state', () => {
        expect(isLoadingSelector(mockState)).toEqual(false);
    });

    it('should select the correct currentPage', () => {
        expect(currentPageSelector(mockState)).toEqual(1);
    });

    it('should select the correct alertHistoryList with filtering and sorting', () => {
        const { selectedCategoryId, searchValue, list } = mockState['alert/history'];
        const filteredEvents = [
            { id: 3, timestamp: 1612051220000, category: 'category1', message: 'Event 3' },
            { id: 1, timestamp: 1612051200000, category: 'category1', message: 'Event 1' },
        ];
        const sortedEvents = [
            { id: 3, timestamp: 1612051220000, category: 'category1', message: 'Event 3' },
            { id: 1, timestamp: 1612051200000, category: 'category1', message: 'Event 1' },
        ];
        filterEvents.mockReturnValue(filteredEvents);
        getSortedListByDate.mockReturnValue(sortedEvents);
        expect(alertHistoryListSelector(mockState)).toEqual(sortedEvents);
        expect(filterEvents).toBeCalledWith(list, selectedCategoryId, searchValue);
        expect(getSortedListByDate).toBeCalledWith(filteredEvents);
    });
});

describe('isEmptyAlertHistoryListSelector', () => {
    it('should return true if the alert history list is empty', () => {
        const fakeState = {
            [ALERT_HISTORY]: {
                [IS_EMPTY_ALERT_HISTORY_LIST]: true,
            },
        };
        expect(isEmptyAlertHistoryListSelector(fakeState)).toBe(true);
    });

    it('should return false if the alert history list is not empty', () => {
        const fakeState = {
            [ALERT_HISTORY]: {
                [IS_EMPTY_ALERT_HISTORY_LIST]: false,
            },
        };
        expect(isEmptyAlertHistoryListSelector(fakeState)).toBe(false);
    });

    it('should safely handle an undefined state', () => {
        expect(isEmptyAlertHistoryListSelector(undefined)).toBeUndefined();
    });
});

describe('listSelector', () => {
    it('should return the list from the state', () => {
        const testList = ['alert1', 'alert2', 'alert3'];
        const state = { [ALERT_HISTORY]: { [LIST]: testList } };
        expect(listSelector(state)).toEqual(testList);
    });

    it('should return null if ALERT_HISTORY does not exist in the state', () => {
        const state = {};
        expect(listSelector(state)).toBeNull();
    });

    it('should return null if LIST does not exist in ALERT_HISTORY', () => {
        const state = { [ALERT_HISTORY]: {} };
        expect(listSelector(state)).toBeNull();
    });

    it('should safely handle undefined or null state', () => {
        expect(listSelector(undefined)).toBeNull();
        expect(listSelector(null)).toBeNull();
    });
});
